<template>
  <router-link
    :to="`/article/${article && article.fields.slug}`"
    class="v-container">
    <img :src="`${imgUrl}?q=40&w=400`">
    <div class="tag-container">
      <span
        v-if="article.fields.payingMembersOnly"
        class="tag is-primary">
        Abonnés
      </span>
      <span
        v-if="article.fields.youtubeVideoId"
        class="tag is-danger">
        <span class="icon is-small">
          <i class="fas fa-play"/>
        </span> Video
      </span>
    </div>
    <div class="v-title">{{ article && article.fields.title }}</div>
  </router-link>
</template>
<style scoped lang="scss">
.icon {
  margin-right: 4px !important;
  font-size: 10px;
}
.tag {
  margin-left: 4px;
}
.v-container {
  position: relative;
  background: #ffffff;
  transition: 0.2s ease-in;
  box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
  &:hover {
    cursor: pointer;
    box-shadow: 0 4px 10px 0 rgba(194, 194, 194, 0.9);
  }
  img {
    height: 120px;
    width: 100%;
    object-fit: cover;
  }
  .v-title {
    padding: 0 1em;
    font-weight: bold;
    font-size: 14px;
    color: #4a4a4a;
    padding-bottom: 1em;
  }
}
a {
  text-decoration: none;
}
.tag-container {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>

<script>
import { getAsset } from "../../../utils/contentful";

export default {
  name: "ArticleListItem",
  props: {
    article: {
      type: Object
    },
    includes: {
      type: Object
    }
  },
  computed: {
    imgUrl() {
      return getAsset(this.includes, this.article.fields.coverImg.sys.id).fields
        .file.url;
    }
  }
};
</script>

<style scoped>
</style>
